import Request from '@/utils/request'

export function sayHiStatus () {
  return Request({
    url: '/api/v2/app/say-hi-video/status',
    method: 'get'
  })
}

export function claimSayHiReward () {
  return Request({
    url: '/api/v2/app/say-hi-video/claim',
    method: 'post'
  })
}

export function submitSayHiVideo (videoUrl, thumbUrl) {
  return Request({
    url: `/api/v2/app/say-hi-video/upload?url=${videoUrl}&thumbnail=${thumbUrl}`,
    method: 'post'
  })
}

export function getVideoList ({ offset, limit }) {
  return Request({
    url: `/api/v2/app/say-hi-video/examples?offset=${offset}&limit=${limit}`,
    method: 'get'
  })
}
